(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-buy-box"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-omt-description]').forEach((desc) => {
    desc.querySelectorAll('li, p').forEach((node) => {
      if (/^\s*taglia\s*:/i.test(node.textContent)) node.remove();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
